// 인증 API. 자체 로그인 + knoka SSO.
//
// knoka 흐름은 서버사이드(백엔드 RP)가 전담한다: 프론트는 전체 페이지 이동으로
// `${API_BASE_URL}/auth/login`(→ knoka)·`/auth/logout`을 호출하고, 세션은
// HTTP-only 쿠키 + `GET /auth/me`로만 확인한다.

import { apiFetch } from '~/api/client'
import type {
    LoginRequest,
    SignupRequest,
    SignupResponse,
    UserProfile,
} from '~/api/types'

/**
 * 자체 이메일/비밀번호 로그인. 성공 시 백엔드가 HTTP-only 쿠키(access/refresh)를
 * set 한다(응답 바디는 사용하지 않는다). 사용자 정보는 이어서 getMe로 받는다.
 */
export async function login(req: LoginRequest): Promise<void> {
    await apiFetch<unknown>('/auth/login', {
        method: 'POST',
        body: req,
        skipAuth: true,
    })
}

/**
 * 회원가입 신청 → 201 { message }. 토큰을 발급하지 않으며(관리자 승인 대기),
 * 중복(409)·검증 오류는 ApiError(message)로 던진다.
 */
export function signup(req: SignupRequest): Promise<SignupResponse> {
    return apiFetch<SignupResponse>('/auth/signup', {
        method: 'POST',
        body: req,
        skipAuth: true,
    })
}

/** 현재 세션 사용자(쿠키 기반). 비로그인이면 401 → ApiError를 던진다. */
export function getMe(): Promise<UserProfile> {
    return apiFetch<UserProfile>('/auth/me', { method: 'GET' })
}
